// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-pdf[data-v-73922792] {\n  max-width: 100%;\n  margin: 0 auto;\n}\n.form-pdf.align-left[data-v-73922792] {\n  margin-left: 0;\n}\n.form-pdf.align-right[data-v-73922792] {\n  margin-right: 0;\n}", ""]);
// Exports
module.exports = exports;
